export default __webpack_public_path__ + "static/media/editWhite.e67b85dd.png";